module.exports = __webpack_public_path__ + "img/inventario-slick.154a7258.svg";